import { render, staticRenderFns } from "./zDelete.vue?vue&type=template&id=6dbbc73e&scoped=true&"
import script from "./zDelete.vue?vue&type=script&setup=true&lang=js&"
export * from "./zDelete.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbbc73e",
  null
  
)

export default component.exports